module.exports = __webpack_public_path__ + "img/icon_close-w.a57fab2e.svg";